import { render, staticRenderFns } from "./BidderRegistrations.vue?vue&type=template&id=fe1cd0bc&scoped=true&"
import script from "./BidderRegistrations.vue?vue&type=script&lang=js&"
export * from "./BidderRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./BidderRegistrations.vue?vue&type=style&index=0&id=fe1cd0bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1cd0bc",
  null
  
)

export default component.exports